import { entrySplitApi as api } from "../entryApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    authControllerSignup: build.mutation<
      AuthControllerSignupApiResponse,
      AuthControllerSignupApiArg
    >({
      query: (queryArg) => ({
        url: `/auth/signup`,
        method: "POST",
        body: queryArg.createUserDto,
      }),
    }),
    authControllerSignin: build.mutation<
      AuthControllerSigninApiResponse,
      AuthControllerSigninApiArg
    >({
      query: (queryArg) => ({
        url: `/auth/signin`,
        method: "POST",
        body: queryArg.authDto,
      }),
    }),
    authControllerSendVerificationCode: build.mutation<
      AuthControllerSendVerificationCodeApiResponse,
      AuthControllerSendVerificationCodeApiArg
    >({
      query: (queryArg) => ({
        url: `/auth/sendVerificationCode`,
        method: "POST",
        body: queryArg.getVerificationCodeDto,
      }),
    }),
    authControllerRefresh: build.query<
      AuthControllerRefreshApiResponse,
      AuthControllerRefreshApiArg
    >({
      query: (queryArg) => ({ url: `/auth/refresh/${queryArg.id}` }),
    }),
    authControllerUser: build.query<
      AuthControllerUserApiResponse,
      AuthControllerUserApiArg
    >({
      query: () => ({ url: `/auth/user` }),
    }),
    authControllerLogout: build.query<
      AuthControllerLogoutApiResponse,
      AuthControllerLogoutApiArg
    >({
      query: () => ({ url: `/auth/logout` }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as combinedApi };
export type AuthControllerSignupApiResponse = /** status 201  */ TokensDto;
export type AuthControllerSignupApiArg = {
  createUserDto: CreateUserDto;
};
export type AuthControllerSigninApiResponse = /** status 201  */ TokensDto;
export type AuthControllerSigninApiArg = {
  authDto: AuthDto;
};
export type AuthControllerSendVerificationCodeApiResponse =
  /** status 201  */ boolean;
export type AuthControllerSendVerificationCodeApiArg = {
  getVerificationCodeDto: GetVerificationCodeDto;
};
export type AuthControllerRefreshApiResponse = /** status 200  */ TokensDto;
export type AuthControllerRefreshApiArg = {
  id: string;
};
export type AuthControllerUserApiResponse = /** status 200  */ UserDto;
export type AuthControllerUserApiArg = void;
export type AuthControllerLogoutApiResponse = unknown;
export type AuthControllerLogoutApiArg = void;
export type TokensDto = {
  accessToken: string;
  refreshToken: string;
  userId: string;
};
export type LanguageType = "en" | "cn" | "cnt";
export type CreateUserDto = {
  username: string;
  password: string;
  verificationCode: string;
  invitationCode: string;
  firstName: string;
  lastName: string;
  mobile?: string;
  defaultLanguage?: LanguageType;
};
export type AuthDto = {
  username: string;
  password: string;
};
export type EmailLanguages = "en" | "cn" | "cnt";
export type GetVerificationCodeDto = {
  username: string;
  userLang?: EmailLanguages;
};
export type QuestionScoreByTypeDto = {
  decisive: number;
  analytical: number;
  creative: number;
  idealistic: number;
  controlling: number;
  affairs: number;
  feel: number;
  interpersonal: number;
};
export type UserDto = {
  id: string;
  name: string;
  username: string;
  firstName?: string;
  lastName?: string;
  alias?: string;
  mobile?: string;
  defaultLanguage: LanguageType;
  recordsCount?: number;
  averageScore?: QuestionScoreByTypeDto;
  isSuperAdmin?: boolean;
  role?: string;
  roleId?: string;
  roleExpiredBy?: string;
  createdAt: string;
  updatedAt: string;
};
export const {
  useAuthControllerSignupMutation,
  useAuthControllerSigninMutation,
  useAuthControllerSendVerificationCodeMutation,
  useAuthControllerRefreshQuery,
  useLazyAuthControllerRefreshQuery,
  useAuthControllerUserQuery,
  useLazyAuthControllerUserQuery,
  useAuthControllerLogoutQuery,
  useLazyAuthControllerLogoutQuery,
} = injectedRtkApi;
